import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { SigningRequestAuthorizationErrorMessage } from '@app/containers/GlobalNavigationBar/useAuthorizeContractSetupStartButtonErrorMessage';
import { getSubscriptionPlan } from '@app/features/subscription/state';
import useMemberPermissions from '@app/hooks/useMemberPermission';
import useUsageCount from '@app/hooks/useUsageCount';
import { useWorkspace } from '@app/hooks/workspace';
import { getNetPermission } from '@app/libs/permission/getNetPermission';

export function useDocumentPermission() {
  // 요금제 권한 판단
  const ws = useWorkspace();
  const { signingRequestCount } = useUsageCount();
  const plan = useSelector(getSubscriptionPlan);

  // 워크스페이스 역할 판단
  const { permissionMap, isLoading } = useMemberPermissions();
  const signingRequestablePermission = useMemo(() => {
    if (!ws.active) {
      return {
        isPermitted: false,
        message: SigningRequestAuthorizationErrorMessage.hasPublicWorkspace,
      };
    }
    if (!plan) {
      // 조직 멤버 && 조직 기능 권한이 없으면 "조직 요금제"가 STOPPED 상태라고 볼 수 있다.
      return { isPermitted: false, message: SigningRequestAuthorizationErrorMessage.noPlan };
    }
    if (signingRequestCount.limit - signingRequestCount.usage <= 0) {
      return {
        isPermitted: false,
        message: SigningRequestAuthorizationErrorMessage.noRemainingCount,
      };
    }
    return {
      ...getNetPermission({
        hasRolePermission: permissionMap.CREATE_DOCUMENT,
      }),
      message: SigningRequestAuthorizationErrorMessage.noPermission,
    };
  }, [permissionMap.CREATE_DOCUMENT, plan, signingRequestCount, ws.active]);

  const assignDocumentPermission = getNetPermission({
    hasRolePermission: permissionMap.ASSIGN_DOCUMENT,
  });

  return {
    isLoading,
    signingRequestablePermission,
    assignDocumentPermission,
    // shareablePermission,
    // downloadablePermission,
    // deletablePermission,
    // readablePermission,
  };
}
